<template>
    <section>
        <v-text-field
            v-model="searchQuery"
            label="Zoeken"
            clearable
            class="mb-4"
            outlined
            rounded
            hide-details="auto"
        ></v-text-field>
        <v-card class="facet-card mb-4" elevation="0">
            <v-card-text>
                <strong>Afstand</strong>
                <v-text-field
                    v-model="postalCode.code"
                    label="Postcode"
                    placeholder="Bv. 1234AB"
                    clearable
                    hide-details="auto"
                    maxlength="6"
                ></v-text-field>
                <div class="mx-n2">
                    <v-slider
                        :disabled="!postalCode.code || postalCode.code.length < 6"
                        v-model="postalCode.distance"
                        min="5"
                        max="100"
                        class="mt-4"
                        step="5"
                    ></v-slider>
                </div>
                <p class="text-right ma-0 mt-n5">{{ distanceLabel }}</p>
            </v-card-text>
        </v-card>
        <div v-for="facet in facets" :key="facet.id">
            <v-card class="facet-card mb-4" elevation="0">
                <v-card-text>
                    <strong>{{ facet.name }}</strong>
                    <ul class="list-unstyled">
                        <li v-for="choice in facet.choices" :key="choice.id">
                            <FacetFilter :facet="facet" :choice="choice"></FacetFilter>
                        </li>
                    </ul>
                </v-card-text>
            </v-card>
        </div>
    </section>
</template>

<script>
import {mapState} from "vuex";
import FacetFilter from "./FacetFilter";
import Vue from "vue";

export default {
    name: "FilterList",
    components: {FacetFilter},
    data: () => ({
        postalCode: {
            code: null,
            distance: 25,
        },
        postalCodeSingleLetterRegex: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{1}$/i,
        postalCodeRegex: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i,
        numberRegex: /^\d+$/,
        updatePostalCodeTimeout: null,
    }),
    computed: {
        searchQuery: {
            get () { return this.filters.searchQuery; },
            set (value) { this.$store.dispatch('updateSearchQuery', value)}
        },
        distanceLabel () {
            return '+'+this.postalCode.distance+' km';
        },
        ...mapState({
            facets: state => state.profile.facets,
            filters: state => state.profile.filters,
        }),
    },
    watch: {
        'postalCode.code' (newCode, oldCode) {
            if (this.updatePostalCodeTimeout) {
                clearTimeout(this.updatePostalCodeTimeout);
            }

            if (!newCode) {
                this.updatePostalCodeTimeout = setTimeout(this.updatePostalCode, 500);
                return;
            }

            const newCodeDigits = newCode.substring(0, 4);
            const digits = parseInt(newCodeDigits);
            if (newCode.length > 7 || newCodeDigits.startsWith('0') || Number.isNaN(digits) || digits > 9999 || !this.numberRegex.test(newCodeDigits)) {
                // Invalid digits.
                Vue.nextTick(() => {
                    this.postalCode.code = oldCode;
                });
                return;
            }

            if (newCode.length === 5) {
                if (!this.postalCodeSingleLetterRegex.test(newCode)) {
                    Vue.nextTick(() => {
                        this.postalCode.code = oldCode;
                    });
                    return;
                }
            } else if (newCode.length === 6) {
                if (!this.postalCodeRegex.test(newCode)) {
                    Vue.nextTick(() => {
                        this.postalCode.code = oldCode;
                    });
                    return;
                }
            }

            this.postalCode.code = this.postalCode.code.toUpperCase();

            this.updatePostalCodeTimeout = setTimeout(this.updatePostalCode, 500);
        },
        'postalCode.distance' () {
            if (this.updatePostalCodeTimeout) {
                clearTimeout(this.updatePostalCodeTimeout);
            }
            this.updatePostalCodeTimeout = setTimeout(this.updatePostalCode, 500);
        },
    },
    mounted () {
        this.postalCode = JSON.parse(JSON.stringify(this.filters.postalCode));
    },
    methods: {
        updatePostalCode () {
            const isValid = this.postalCodeRegex.test(this.postalCode.code);

            this.$store.dispatch('updatePostalCode', isValid ? JSON.parse(JSON.stringify(this.postalCode)) : { code: null, distance: 25 });
        },
    },
}
</script>

<style scoped>

</style>
